import React, { useState, useEffect } from 'react';
import { FaGithub, FaExternalLinkAlt, FaArrowLeft, FaReact, FaNodeJs, FaPython, FaDatabase } from 'react-icons/fa';
import { SiMongodb, SiExpress, SiFirebase, SiRedux, SiTensorflow, SiFlask, SiStripe } from 'react-icons/si';
import '../styles/AllProjects.css';

const dummyProjects = [
  {
    
    _id: '1',
    title: 'WellScope',
    description: 'Built the official website for the ACM Student Chapter at Medi-Caps University from scratch as both President and sole developer. Designed and developed a full-stack MERN application with a cyberpunk-inspired UI featuring a terminal boot sequence, starfield parallax, and scroll-reveal animations. The platform serves as the chapters digital home — showcasing events, team members, achievements, and a gallery — with a custom admin dashboard for content management backed by Firebase Firestore and JWT-based authentication. Deployed on Vercel (frontend) and Render (backend)',
    technologies: ['React', 'Node.js', 'SupaBase', 'Express', 'FastAPI', 'PostgreSQL',],
    imageUrl: '/wellscope.png',
    projectUrl: 'https://wellscope.vercel.app/',
    githubUrl: 'https://github.com/Atharv-Untwale/wellscope'
  },
  {
    _id: '2',
    title: 'MU-ACM Website',
    description: 'Built the official website for the ACM Student Chapter at Medi-Caps University from scratch as both President and sole developer. Designed and developed a full-stack MERN application with a cyberpunk-inspired UI featuring a terminal boot sequence, starfield parallax, and scroll-reveal animations. The platform serves as the chapters digital home — showcasing events, team members, achievements, and a gallery — with a custom admin dashboard for content management backed by Firebase Firestore and JWT-based authentication. Deployed on Vercel (frontend) and Render (backend)',
    technologies: ['React', 'Node.js', 'SupaBase', 'Express'],
    imageUrl: '/mu-acm.png',
    projectUrl: 'https://mu-acm.vercel.app/',
    githubUrl: 'https://github.com/Atharv-Untwale/mu-acm'
  },
  {
    _id: '3',
    title: 'BlockChain Simulator',
    description: 'The Blockchain Simulator is an interactive web application built using React to demonstrate the core working principles of blockchain technology in a simplified and visual manner. The project is designed as a learning and demonstration tool, helping users understand how transactions, blocks, hashing, and mining work together to maintain blockchain integrity.',
    technologies: ['React'],
    imageUrl: '/Blockchain Simulator.png',
    projectUrl: 'https://blockchain-simulator-murex.vercel.app/',
    githubUrl: 'https://github.com/Atharv-Untwale/Blockchain-Simulator'
  },
  {
    _id: '4',
    title: 'GitRoast',
    description: 'Git Roast is a developer-focused platform designed to help programmers grow through honest, constructive feedback. It provides a space where developers can showcase their projects, share their code, and receive detailed reviews from peers, mentors, and the wider tech community. Unlike traditional platforms that often rely on surface-level appreciation, Git Roast promotes meaningful technical discussions that focus on improving code quality, optimizing architecture, and strengthening problem-solving approaches.',
    technologies: ['React', 'TalwindCSS'],
    imageUrl: '/GitRoast.png',
    projectUrl: 'https://git-roast-pi.vercel.app/',
    githubUrl: 'https://github.com/Atharv-Untwale/GitRoast'
  },
  {
    _id: '5',
    title: 'Div-Trek',
    description: 'A cross-platform mobile task management application with real-time synchronization across devices using Firebase. Features include collaborative task boards, priority management with color coding, deadline reminders with push notifications, file attachments, commenting system, and offline mode with automatic sync when online. Users can create teams, assign tasks, track progress, and visualize productivity with detailed analytics.',
    technologies: ['React', 'TalwindCSS', 'Nodejs'],
    imageUrl: '/DivTrek.png',
    projectUrl: 'https://divtrek.vercel.app/#home',
    githubUrl: 'https://github.com/Atharv-Untwale/Div-Trek'
  },
];

const AllProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setProjects(dummyProjects);
    setLoading(false);
  }, []);

  const getTechIcon = (tech) => {
    const techLower = tech.toLowerCase();
    if (techLower.includes('react')) return <FaReact />;
    if (techLower.includes('node')) return <FaNodeJs />;
    if (techLower.includes('python')) return <FaPython />;
    if (techLower.includes('mongodb')) return <SiMongodb />;
    if (techLower.includes('express')) return <SiExpress />;
    if (techLower.includes('firebase')) return <SiFirebase />;
    if (techLower.includes('redux')) return <SiRedux />;
    if (techLower.includes('tensorflow')) return <SiTensorflow />;
    if (techLower.includes('flask')) return <SiFlask />;
    if (techLower.includes('stripe')) return <SiStripe />;
    if (techLower.includes('database')) return <FaDatabase />;
    return <span className="tech-letter">{tech.charAt(0)}</span>;
  };

  if (loading) {
    return (
      <div className="all-projects-page">
        <div className="loading">Loading all projects...</div>
      </div>
    );
  }

  return (
    <div className="all-projects-page">
      <div className="all-projects-header">
        <a href="/" className="back-btn">
          <FaArrowLeft /> Back to Home
        </a>
        <h1 className="page-title">All Projects</h1>
        <p className="page-subtitle">A comprehensive collection of my work</p>
      </div>

      <div className="all-projects-container">
        {projects.length === 0 ? (
          <div className="loading">No projects found.</div>
        ) : (
          <div className="all-projects-grid">
            {projects.map((project) => (
              <div key={project._id} className="all-project-card">
                <div className="all-project-image">
                  <img src={project.imageUrl} alt={project.title} />
                </div>
                <div className="all-project-content">
                  <h3 className="all-project-title">{project.title}</h3>
                  <p className="all-project-description">{project.description}</p>
                  <div className="all-project-tech">
                    {project.technologies.map((tech, index) => (
                      <span key={index} className="tech-tag">
                        {getTechIcon(tech)}
                        <span>{tech}</span>
                      </span>
                    ))}
                  </div>
                  <div className="all-project-links">
                    {project.projectUrl && (
                      <a href={project.projectUrl} target="_blank" rel="noopener noreferrer" className="link-btn btn-primary">
                        <FaExternalLinkAlt /> Live Demo
                      </a>
                    )}
                    {project.githubUrl && (
                      <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className="link-btn btn-secondary">
                        <FaGithub /> GitHub
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AllProjects;